jQuery(document).ready(function( $ ){
    var gmapDependentComponentsInstanciated = false;
    var instanciateGmapDependentComponents = function() {
        if(!gmapDependentComponentsInstanciated) {
            gmapDependentComponentsInstanciated = true;

            // Instanciate agencies maps
            var $agenciesMap = $('#map');
            if($agenciesMap.length && window.gmapApiLoaded) {
                new AgenciesMap($agenciesMap);
            }
        }
    };

    // Scroll navbar (ajout class sticky)
    if(window.matchMedia("(max-width: 991px)").matches) {
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 100) {
                $("aside.top-bar").addClass("sticky");
                $("nav.main-nav").addClass("sticky");
            } else {
                $("aside.top-bar").removeClass("sticky");
                $("nav.main-nav").removeClass("sticky");
            }

            if(scroll >= 1100) {
                $("section.fixed-banner").addClass("sticky");
            } else {
                $("section.fixed-banner").removeClass("sticky");
            }
        });
    } else {
        if( $('body').hasClass('home') ){
            $(window).scroll(function() {
                var scroll = $(window).scrollTop();

                if (scroll >= 800) {
                    $("aside.top-bar").addClass("sticky");
                    $("nav.main-nav").addClass("sticky");
                } else {
                    $("aside.top-bar").removeClass("sticky");
                    $("nav.main-nav").removeClass("sticky");
                }
            });
        } else {
            $(window).scroll(function() {
                var scroll = $(window).scrollTop();

                if (scroll >= 50) {
                    $("aside.top-bar").addClass("sticky");
                    $("nav.main-nav").addClass("sticky");
                } else {
                    $("aside.top-bar").removeClass("sticky");
                    $("nav.main-nav").removeClass("sticky");
                }

                if(scroll >= 200) {
                    $("section.fixed-banner").addClass("sticky");
                } else {
                    $("section.fixed-banner").removeClass("sticky");
                }
            });
        }
    }
    // Fin scroll de la navbar

    // Slider page accueil
    var $slider = $('#slider-hero').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        arrows: false,
        appendDots: $('.slider-dots .container'),
        dots: true,
        fade: true
    });

    var $temoignagesSlide = [...$('.slider-temoignages__slide')];
    if($temoignagesSlide.length > 1) {
        var $sliderTemoignages = $('.slider-temoignages').slick({
            autoplay: false,
            arrows: true,
            dots: true,
            centerMode: true,
            centerPadding: '24%',
            infinite: true,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        centerPadding: '14%',
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: '50px',
                        dots: false,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        centerPadding: '25px',
                    }
                },
            ]
        });
    }

    // FAQ
    $('.accordion_title').click(function() {
        var $this = $(this);
        var $parent = $this.parent('.accordion');
        var $openedBoxes = $('.accordion.active');

        if($parent.length) {
            $('.accordion_content').removeClass('active');

            if($openedBoxes.length) {
                $openedBoxes.each(function(index, box) {
                    if(box === $parent[0]) {
                        $openedBoxes.splice(index, 1);
                    }
                });
                if($openedBoxes.length) {
                    $openedBoxes.removeClass('active');
                }
            }

            $parent.toggleClass('active');
        }
    });

    // Agencies map
    $(window).on('google-map-api-loaded', function() {
        instanciateGmapDependentComponents();
    });
    if(window.gmapApiLoaded && !gmapDependentComponentsInstanciated) {
        instanciateGmapDependentComponents();
    }
});

/* var slides = document.querySelectorAll('#slider-logo .slide-logos');
var currentSlide = 0;
var slideInterval = setInterval(nextSlide,2000);

function nextSlide() {
    slides[currentSlide].className = 'slide-logos';
    currentSlide = (currentSlide+1)%slides.length;
    slides[currentSlide].className = 'slide-logos visible';
}*/
